import { apiFetch } from "../utils/api";

/**
 * Server-side product search (name/SKU/size/variants/price/…).
 * Requires logged-in backoffice user (Bearer token).
 */
export async function searchProductsServer({
  q,
  page = 1,
  limit = 10,
  categoryId = null,
}) {
  const params = new URLSearchParams({
    q: String(q || "").trim(),
    page: String(page),
    limit: String(limit),
  });

  if (categoryId) {
    params.set("categoryId", categoryId);
  }

  const response = await apiFetch(`/products/search?${params.toString()}`, {
    method: "GET",
  });

  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(data.error || "Product search request failed");
  }
  return data;
}
